import { render } from "./matches.vue?vue&type=template&id=ed817cca&scoped=true"
import script from "./matches.vue?vue&type=script&lang=js"
export * from "./matches.vue?vue&type=script&lang=js"

import "./matches.vue?vue&type=style&index=0&id=ed817cca&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed817cca"]])

export default __exports__